export const VILLAGES = [
  {
    label: "PIÓDÃO",
    value: "piodao",
    img: "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2019/02/MG_3625.jpg",
  },
  {
    label: "SORTELHA",
    value: "sortelha",
    img: "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2019/02/sortelha-3.jpg",
  },
  {
    label: "CASTELO NOVO",
    value: "castelo_novo",
    img: "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2019/02/AH-Castelo-Novo-e1605887247193.jpg",
  },
  {
    label: "LINHARES DA BEIRA",
    value: "linhares_da_beira",
    img: "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2019/02/AH-Trancoso.jpg",
  },
  {
    label: "CASTELO RODRIGO",
    value: "castelo_rodrigo",
    img: "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/12/castelo-rodrigo-3-e1611222463264.jpg",
  },
  {
    label: "IDANHA-A-VELHA",
    value: "idanha_a_velha",
    img: "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/12/AH-Idanha-a-Velha-1.jpg",
  },
  {
    label: "CASTELO MENDO",
    value: "castelo_mendo",
    img: "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/12/castelo_mendo-1453-e1605890019407.jpg",
  },
  {
    label: "MARIALVA",
    value: "marialva",
    img: "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2019/02/IH0A2023_mar_trat.jpg",
  },
  {
    label: "ALMEIDA",
    value: "almeida",
    img: "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2019/02/almeida-1034.jpg",
  },
  {
    label: "MONSANTO",
    value: "monsanto",
    img: "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/12/AH-Monsanto.jpg",
  },
  {
    label: "TRANCOSO",
    value: "trancoso",
    img: "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/12/AH-Trancoso-1.jpg",
  },
  {
    label: "BELMONTE",
    value: "belmonte",
    img: "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2019/02/belmonte-11.jpg",
  },
];

export const VILLAGES_OBJ = {
  almeida: "Almeida",
  belmonte: "Belmonte",
  castelo_mendo: "Castelo Mendo",
  castelo_novo: "Castelo Novo",
  castelo_rodrigo: "Castelo Rodrigo",
  idanha_a_velha: "Idanha-A-Velha",
  linhares_da_beira: "Linhares da Beira",
  marialva: "Marialva",
  monsanto: "Monsanto",
  piodao: "Piódão",
  sortelha: "Sortelha",
  trancoso: "Trancoso",
};

export const VILLAGES_IMAGES = {
  almeida:
    "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2019/02/almeida-1034.jpg",
  belmonte:
    "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2019/02/belmonte-11.jpg",
  castelo_mendo:
    "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/12/castelo_mendo-1453-e1605890019407.jpg",
  castelo_novo:
    "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2019/02/AH-Castelo-Novo-e1605887247193.jpg",
  castelo_rodrigo:
    "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/12/castelo-rodrigo-3-e1611222463264.jpg",
  idanha_a_velha:
    "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/12/AH-Idanha-a-Velha-1.jpg",
  linhares_da_beira:
    "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2019/02/AH-Trancoso.jpg",
  marialva:
    "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2019/02/IH0A2023_mar_trat.jpg",
  monsanto:
    "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/12/AH-Monsanto.jpg",
  piodao:
    "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2019/02/MG_3625.jpg",
  sortelha:
    "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2019/02/sortelha-3.jpg",
  trancoso:
    "https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/12/AH-Trancoso-1.jpg",
};
